<template>
  <div>
    <div class="title">
      <h2 v-html-safe="product.payload.product" class="d-inline-block"></h2>
      <font-awesome-icon class="text-primary" :icon="['far', 'stars']" :style="iconStyle"></font-awesome-icon>
    </div>
    <p v-html-safe="product.payload.message[0]" class="mb-5"></p>
    <div class="data-container d-flex flex-column align-items-center">
      <h5 v-html-safe="product.payload.message[1]"></h5>
      <p class="h2 mt-2 daysOnLot">
        {{
          $tc(
            `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['NEW-LISTING']}.days`,
            product.payload.data.daysOnLot,
            { daysOnLot: product.payload.data.daysOnLot }
          )
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewListing',
  props: {
    product: {
      validator: prop => typeof prop === 'object' || prop === undefined,
      required: true,
    },
  },
  data() {
    return {
      iconStyle: {
        marginLeft: '8px',
        fontSize: '18px',
      },
    };
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.data-container {
  border-top: 1px solid rgb(218, 226, 234);
  border-bottom: 1px solid rgb(218, 226, 234);
  padding: 32px 0;

  .daysOnLot {
    color: $primary;
    font-size: 22px;
    font-weight: bold;
    line-height: 27.5px;
    background-color: $primary-light-blue;
    padding: 12px;
    border-radius: 6px;
  }
}
</style>
